import { type Command } from "@telespot/core";

export const REVOKE_ROLES = "users:revokeRoles";

export interface RevokeRolesPayload {
  userId: string;
  roles: string[];
}

export class RevokeRoles implements Command<typeof REVOKE_ROLES, RevokeRolesPayload> {
  public readonly name = REVOKE_ROLES;
  constructor(public readonly details: Readonly<RevokeRolesPayload>) { }
}
